<template>
	<div class="menu2">
        <main>
            <div class="list">
                <h2>装车录入</h2>

                <van-field v-model="tel" label="电话" readonly />
                <van-field v-model="name" label="姓名" readonly />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="gongsi"
                    label="饲料公司"
                    placeholder="点击选择"
                    @click="showPicker1 = true"
                />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="zhuchang"
                    label="运到猪场"
                    placeholder="点击选择"
                    @click="showPicker2 = true"
                />
                
                <van-field
                    v-model="chepai"
                    center
                    label="车牌"
                    placeholder="请输入车牌"
                >
                    <template #button>
                        <van-button size="mini" type="danger" @click="searchCar()">搜索</van-button>
                    </template>
                </van-field>

                <van-field v-model="number" type="number"  label="运载量(吨)"  />

                <van-field v-model="hou3" label="开始里程"  />
                <van-field v-model="hou4" label="结束里程"  />

                <div style="border:solid 1px red">
                    <p style="margin-left:16px">饲料厂过磅重量</p>
                    <van-field v-model="hou1" type="number"  label=" 装前重量（皮重-公斤）" />
                    <van-field v-model="hou2" type="number"  label="装后重量（毛重-公斤）" />
                    <van-field v-model="flow" type="number"  label="销方重量(净重-公斤)" />
                </div>

                <div style="border:solid 1px red;margin-top:10px">
                    <p style="margin-left:16px">猪场过磅重量</p>
                    <van-field @blur="handleInput1" v-model="flow1" type="number"  label="进场重量(公斤)"  />
                    <van-field @blur="handleInput2" v-model="flow2" type="number"  label="出场重量(公斤)"  />
                    <van-field v-model="now" label="本次重量" readonly />
                </div>
                
                <van-field v-model="beizhu" label="备注"  />

                <h4>请上传进场照片，出场照片，磅码单以及整车照片</h4>
                <van-uploader  v-model="fileList" multiple :max-count="8"  :before-read="beforeRead"/>
                <br><br>
                <br><br>
                <van-button type="danger" style="width:100%" @click="sub()">提交</van-button>

                <van-popup v-model:show="showPicker1" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns1"
                        @confirm="onConfirm1"
                        @cancel="showPicker1 = false"
                    />
                    </van-popup>

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns3"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>
            </div>
        </main>
    </div>
</template>

<script>
    import { url2,carList } from '../router/api';
    import option from "../config/option.js"

	export default{
		data(){
			return{
                fileList: [],
                loading:'',
                name:'',
                tel:'',
                gongsi:'',
                zhuchang:'',
                chepai:'',
                number:'',
                flow:'',
                flow1:'',
                flow2:'',
                hou1:'',
                hou2:'',
                hou3:'',
                hou4:'',
                now:'',
                beizhu:'',

                columns1:[],
                columns2:[],
                columns3:[],
                showPicker1:false,
                showPicker2:false,
                showPicker3:false,
            }
        },

        mounted() {
            const elementToRemove = '全部';
            this.columns1 = option.siliao.filter(item => item !== elementToRemove);
            this.columns2 = option.zhuchang.filter(item => item !== elementToRemove);

            this.name = this.$route.query.name
            this.tel = this.$route.query.tel
        },

        watch: {
            flow1(val) {
                this.now = this.flow1 - this.flow2;
                this.now = this.now.toFixed('2')
            },
            flow2(val) {
                this.now = this.flow1 - this.flow2;
                this.now = this.now.toFixed('2')
            },
            hou1(val) {
                this.flow = this.hou2 - this.hou1;
                this.flow = this.flow.toFixed('2')
            },
            hou2(val) {
                this.flow = this.hou2 - this.hou1;
                this.flow = this.flow.toFixed('2')
            },
        },

		methods: {
            searchCar() {
                carList({
                    id:'',
                    chepai:this.chepai ? this.chepai: '',
                    xz_status:'',
                    gongsi: '' ,
                }).then(res=> {
                    if(res.code==1) {
                        res.data.map(item=>{
                            item.text = item.chepai
                            delete (item.chepai)
                        })
                        this.columns3 = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
                this.showPicker3 = true
            },

            onConfirm1(value) {
                this.gongsi = value;
                this.showPicker1 = false;
            },
            onConfirm2(value) {
                this.zhuchang = value;
                this.showPicker2 = false;
            },
            onConfirm3(value) {
                this.chepai = value.text
                this.number = value.yzl
                this.showPicker3 = false;
            },

            handleInput1(e) {
                this.flow1 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },
            handleInput2(e) {
                this.flow2 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },

            beforeRead(file){
               return this.$compress(file)
            },


            sub() {
                if(this.gongsi=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入饲料公司',
                    }).then(() => {
                        return;
                    });
                } else if(this.zhuchang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入运到猪场',
                    }).then(() => {
                        return;
                    });
                } else if(this.chepai=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入车牌',
                    }).then(() => {
                        return;
                    });
                } else if(this.number=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入运载量',
                    }).then(() => {
                        return;
                    });
                } else if(this.hou1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装车前重量',
                    }).then(() => {
                        return;
                    });
                } else if(this.hou2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装车后重量',
                    }).then(() => {
                        return;
                    });
                }  else if(this.hou3=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入开始里程',
                    }).then(() => {
                        return;
                    });
                } else if(this.hou4=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入结束里程',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入销方重量',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入进场重量',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入出场重量',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.sure()
                    }).catch(() => {});
                }
            },

            sure() {
                 if(this.fileList.length<4) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请最少上传四张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                        this.axios.post(url2+'upload2',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure2(res.data.data)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                }
            },

            sure2(photo) {
                this.axios.get(url2+'subList2', {
                    params:{
                        tel: this.tel,
                        name: this.name,
                        gongsi: this.gongsi,
                        zhuchang: this.zhuchang,
                        chepai: this.chepai,
                        number: this.number,
                        hou1: this.hou1,
                        hou2: this.hou2,
                        hou3: this.hou3,
                        hou4: this.hou4,
                        flow:this.flow,
                        flow1:this.flow1,
                        flow2:this.flow2,
                        now:this.now,
                        beizhu:this.beizhu,
                        url:photo.toString()
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.fileList = []
                            this.flow = ''
                            this.flow1 = ''
                            this.flow2 = ''
                            this.gongsi = ''          
                            this.zhuchang = ''
                            this.chepai = ''
                            this.number = ''
                            this.now = ''
                            this.beizhu = ''
                            this.hou1 = ''
                            this.hou2 = ''
                            this.hou3 = ''
                            this.hou4 = ''
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },
        }
    }
</script>


<style scoped="scoped" lang='less'>
    .menu2 main {
        font-size: 14px;
        padding: 40px 16px 28px 16px;
        background-color: #FFDCA3;
    }
    .menu2 .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .menu2 h2 {
        text-align: center;
        margin-bottom: 20px;
    }
   
    .menu2 /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .menu2 h4 {
        text-indent: 16px;
    }
    .menu2 /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
</style>

